// extracted by mini-css-extract-plugin
module.exports = {"container":"SliderLogicJumps_container__2RS_O","logicContainer":"SliderLogicJumps_logicContainer__-fEDQ","addJumpButton":"SliderLogicJumps_addJumpButton__2q3mh"};